<template>
  <v-container
    :id="'row-' + index"
    v-for="index in filesLoaded.length + 1"
    :key="index"
  >
    <v-row no-gutters>
      <v-col cols="5">
        <v-file-input
          type="file"
          @change="onFileChange($event, index - 1)"
          :disabled="
            !selectedBank[index - 1] || filesLoaded[index - 1] !== undefined
          "
          accept="csv, xlxs"
          :id="'input-' + index"
        />
      </v-col>
      <v-col cols="5">
        <v-select
          :items="['Chase', 'Amex', 'Discover']"
          label="Select Bank"
          solo
          v-model="selectedBank[index - 1]"
          :disabled="filesLoaded[index - 1] !== undefined"
        />
      </v-col>
      <v-col cols="2">
        <v-btn
          @click="clearFile(index - 1)"
          v-if="filesLoaded[index - 1]"
          color="primary"
          elevation="2"
        >
          Clear
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
  <v-btn
    @click="resetAll"
    v-if="rawTableData.length > 0"
    color="primary"
    elevation="2"
    >Reset</v-btn
  >
  <v-btn
    @click="uploadData"
    v-if="rawTableData.length > 0"
    color="primary"
    elevation="2"
    >Upload</v-btn
  >
  <transaction-table :table-data="rawTableData" :is-editable="false" />
</template>

<script lang="ts">
  import { defineComponent, ref } from "vue";

  import { Transaction, FileLoaded } from "../data-types";
  import {
    getDataFromExcel,
    chooseBank,
    validateTransaction,
  } from "../util/file-util";
  import { addTransaction } from "../firebase/manageData";

  import TransactionTable from "../components/TransactionTable.vue";

  export default defineComponent({
    name: "UploadView",
    components: {
      TransactionTable,
    },
    setup() {
      const rawTableData = ref<Transaction[]>([]);
      const selectedBank = ref<string[]>([""]);
      const filesLoaded = ref<FileLoaded[]>([]);

      const onFileChange = async (event: any, index: number) => {
        if (event.target.files[0]) {
          const fileLoaded: FileLoaded = {
            file: event.target.files[0],
            createdAt: new Date(),
          };
          if (filesLoaded.value.length < index) {
            filesLoaded.value.push(fileLoaded);
          } else {
            filesLoaded.value[index] = fileLoaded;
          }
          if (selectedBank.value.length < index) {
            selectedBank.value.push("");
          }
          try {
            const rawData: any = await getDataFromExcel(event.target.files[0]);
            const transaction = chooseBank(
              selectedBank.value[index],
              rawData,
              filesLoaded.value[index]
            );
            if (transaction && transaction !== undefined) {
              if (!validateTransaction(transaction)) {
                alert("Make sure the file matches the bank");
                clearFile(index);
              } else {
                rawTableData.value.push(...transaction);
              }
            }
          } catch (error) {
            alert("Make sure the file matches the bank");
            clearFile(index);
          }
        }
      };

      const uploadData = async () => {
        if (rawTableData.value.length > 0) {
          try {
            rawTableData.value.forEach((row) => {
              addTransaction(row);
            });
            alert("Upload successful");
          } catch (error) {
            alert("No access");
          }
        }
      };

      const resetAll = () => {
        let i = 0;
        while (filesLoaded.value.length > i) {
          clearFile(i);
          i++;
        }
      };

      const clearFile = (index: number) => {
        rawTableData.value = rawTableData.value.filter((row) => {
          return row.createdAt !== filesLoaded.value[index].createdAt;
        });
        const rowToRemove = document.getElementById(
          "row-" + (index + 1).toString()
        );
        rowToRemove?.remove();
      };

      return {
        onFileChange,
        selectedBank,
        rawTableData,
        resetAll,
        uploadData,
        filesLoaded,
        clearFile,
      };
    },
  });
</script>
